import React from 'react';
import PropTypes from 'prop-types';
import Modal from 'Components/Modal';
import EnvironmentManager from 'Utils/environmentManager';

const MediaPlayerErrorModal = props => {
  const { modalClose, modalData: { tjkMediaPlayerModalError } } = props;
  
  const fotoTitle = EnvironmentManager.getMessageText({ key: 'title_tjk_results_no_foto_finish' }) || 'Foto Finiş Bulunamadı';
  const fotoDesc = EnvironmentManager.getMessageText({ key: 'description_tjk_results_no_foto_finish' }) || 'Bu koşu için foto finiş görseli bulunmamaktadır.';
  const videoTitle = EnvironmentManager.getMessageText({ key: 'title_tjk_results_no_video' }) || 'Koşu Videosu Bulunamadı';
  const videoDesc = EnvironmentManager.getMessageText({ key: 'description_tjk_results_no_video' }) || 'Bu koşu için video bulunmamaktadır.';

  const title = tjkMediaPlayerModalError.type === 'video' ? videoTitle : fotoTitle;
  const text = tjkMediaPlayerModalError.type === 'video' ? videoDesc : fotoDesc;

  return (
    <Modal
      className="horse-racing-mediplayer-modal"
      onClose={ modalClose }
      title={ title }
    >
      { text }
    </Modal>
  );
};

MediaPlayerErrorModal.propTypes = {
  modalClose: PropTypes.func,
  props: PropTypes.object,
  tjkMediaPlayerModalError: PropTypes.object,
  modalData: PropTypes.object
};

export default MediaPlayerErrorModal;
